import { render, staticRenderFns } from "./BreaksReviewCenterPlaceholder.vue?vue&type=template&id=3a531278&"
import script from "./BreaksReviewCenterPlaceholder.vue?vue&type=script&setup=true&lang=js&"
export * from "./BreaksReviewCenterPlaceholder.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports